import React from "react";
import { Button, Modal } from "semantic-ui-react";

const DeleteHostModal = ({
  openDeleteHost,
  setOpenDeleteHost,
  selectedItem,
  handleDeleteHost,
}) => {
  return (
    <Modal
      closeIcon
      size="small"
      open={openDeleteHost}
      onClose={() => setOpenDeleteHost(false)}
    >
      <Modal.Header>Confirm Deletion</Modal.Header>
      <Modal.Content>
        Are you sure you want to delete the host{" "}
        {selectedItem && selectedItem.Host}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpenDeleteHost(false)}>Cancel</Button>
        <Button type="submit" negative onClick={handleDeleteHost}>
          Delete
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export { DeleteHostModal };
